import React from "react";
import Autosuggest from "react-autosuggest";

const AirportDestination = ({
  index,
  destinationValue,
  airportDetails,
  changeDestinationInput,
  destinationSelected,
  desSuggestion,
  setDesSuggestion,
}) => {
  // const escapeRegexCharacters = (str) => {
  //   return str.replace(/[.*+?^${}()|[]]/g, "$&");
  // };

  const getSuggestions = (value) => {
    // const escapedValue = escapeRegexCharacters(value.trim());
    // if (escapedValue === "") {
    //   return [];
    // }
    // debugger;
    // const regex = new RegExp(`^${escapedValue}`, "i");
    const filterResult = airportDetails.filter((airport) =>
      airport.label.toLowerCase().includes(value.trim().toLowerCase())
    );
    return filterResult;
  };

  const onSuggestionsFetchRequested = ({ value }) => {
    setDesSuggestion(getSuggestions(value));
  };

  const onSuggestionSelected = (event, { suggestionValue }) => {
    destinationSelected(suggestionValue);
  };

  const onSuggestionsClearRequested = () => {
    setDesSuggestion([]);
  };

  const getSuggestionValue = (suggestion) => {
    return suggestion;
  };

  const renderSuggestion = (suggestion) => {
    return <div> {suggestion.label} </div>;
  };

  const renderInputComponent = (props) => (
    <input {...props} className="form-control" required />
  );

  return (
    <Autosuggest
      suggestions={desSuggestion}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={renderSuggestion}
      focusInputOnSuggestionClick={true}
      onSuggestionSelected={onSuggestionSelected}
      inputProps={{
        placeholder: "Airport Destination",
        value: destinationValue[index].label,
        onChange: (e) => changeDestinationInput(e.target.value, index),
        id: `flightLegs.return[${index}].airportDestinationId`,
        name: `flightLegs.return[${index}].airportDestinationId`,
      }}
      renderInputComponent={renderInputComponent}
    />
  );
};

export default AirportDestination;
